'use client';

import { Button } from '@workspace/ui/components/button';
import { Input } from '@workspace/ui/components/input';
import { cn } from '@workspace/ui/lib';
import { Eye, EyeOff } from 'lucide-react';
import * as React from 'react';

interface PasswordInputProps extends React.ComponentProps<typeof Input> {
  type?: 'password';
}

function PasswordInput({ className, ...props }: PasswordInputProps) {
  const [showPassword, setShowPassword] = React.useState(false);

  return (
    <div className="relative">
      <Input
        type={showPassword ? 'text' : 'password'}
        className={cn('pr-12', className)}
        capitalizeFirstLetter={false}
        {...props}
      />
      <Button
        type="button"
        variant="ghost"
        size="sm"
        className="absolute top-1/2 right-2 h-8 w-8 -translate-y-1/2"
        onClick={() => setShowPassword(!showPassword)}
        tabIndex={-1}
      >
        {!!props.value &&
          (showPassword ? (
            <>
              <EyeOff className="text-grey-500 h-4 w-4" />
              <span className="sr-only">Hide password</span>
            </>
          ) : (
            <>
              <Eye className="text-grey-500 h-4 w-4" />
              <span className="sr-only">Show password</span>
            </>
          ))}
      </Button>
    </div>
  );
}

export { PasswordInput };
